<div class="send-papers">
  <header class="header p-3" *ngIf="isVisaoMobile; else headerDesktopTablet">
    <div class="d-flex justify-content-between align-items-center">
      <div
        class="Heading20 col-3"
        [ngClass]="{
          Heading16: isVisaoMobile && !openInputSearchAssunto,
          'd-none': isVisaoMobile && openInputSearchAssunto
        }"
      >
        Documentos enviados
      </div>

      <div class="d-flex search">
        <div
          class="select-search-assunto"
          [ngClass]="{
            'open-select-search-assunto': openInputSearchAssunto,
            'padding-select-search': !isPaddingSelect
          }"
        >
          <app-input-search
            [placeholder]="'Pesquisar por assunto'"
            (eventSearch)="searchDocumentAssunto($event)"
            (expandirInput)="openInputSearchAssunto = $event"
          ></app-input-search>
        </div>
        <div
          class="marcador"
          [ngClass]="{ 'd-none': isVisaoMobile && openInputSearchAssunto }"
          [ngStyle]="{ 'margin-left': isVisaoMobile ? '7px' : '16px' }"
        >
          <app-list-tag (eventTag)="filterTag($event)"></app-list-tag>
        </div>
      </div>
    </div>
  </header>
  <ng-template #headerDesktopTablet>
    <header class="row header" #headerDesktopTablet>
      <div
        class="Heading20 col-3 d-flex align-items-center"
        [ngClass]="{
          Heading16: isVisaoMobile && !openInputSearchAssunto,
          'd-none': isVisaoMobile && openInputSearchAssunto
        }"
      >
        Documentos enviados
      </div>
      <div class="d-flex justify-content-end search col-9">
        <div
          class="select-search-assunto col-6 pr-0"
          [ngClass]="{
            'open-select-search-assunto': openInputSearchAssunto,
            'padding-select-search': !isPaddingSelect
          }"
        >
          <app-input-search
            [placeholder]="'Pesquisar por assunto'"
            (eventSearch)="searchDocumentAssunto($event)"
            (expandirInput)="onFocusInputSearchAssunto($event)"
          ></app-input-search>
        </div>
        <div
          class="marcador"
          [ngClass]="{ 'd-none': isVisaoMobile && openInputSearchAssunto }"
          [ngStyle]="{ 'margin-left': isVisaoMobile ? '7px' : '16px' }"
        >
          <app-list-tag (eventTag)="filterTag($event)"></app-list-tag>
        </div>
      </div>
    </header>
  </ng-template>

  <div class="app-kanban-documentos d-flex">
    <div class="kanban-documents-desktop-tablet w-100">
      <div class="col-4 px-0" *ngFor="let field of kanbanField">
        <app-kanban-documents-field
          [chamador]="'area-logged'"
          [situacaoPaper]="'enviados'"
          [title]="field.title"
          [color]="field.color"
          [colorDark]="field.colorDark"
          [isShippable]="field.isShippable"
          [papers]="field.papers"
          [imageEmpty]="field.imageEmpty"
          [messageEmpty]="field.messageEmpty"
          (eventCard)="eventCard(field.signStatus, $event)"
          (eventKanban)="eventKanbanEmitter(field.signStatus, $event)"
          (eventCarregarMaisItens)="carregarMaisPorStatus(field.signStatus)"
          class="flex-grow-1"
        ></app-kanban-documents-field>
      </div>
    </div>
    <div class="mobile flex-grow-1">
      <div class="d-flex mx-2 mb-1 justify-content-around">
        <div
          class="selector d-flex align-items-center pl-1"
          *ngFor="let field of kanbanField"
          (click)="changeField(field)"
          [ngClass]="isFieldSelected(field) ? 'selected' : 'wBody10'"
        >
          <div class="mb-1">
            {{ field.titleMobile }}
          </div>
          <div
            class="number-mobile mb-1 ml-2 d-flex justify-content-center border rounded"
          >
            {{ field.papers.length }}
          </div>
        </div>
      </div>
      <app-kanban-documents-field
        *ngIf="kanbanSelected !== undefined"
        [chamador]="'area-logged'"
        [situacaoPaper]="'enviados'"
        [title]="kanbanSelected.title"
        [color]="kanbanSelected.color"
        [colorDark]="kanbanSelected.colorDark"
        [isShippable]="kanbanSelected.isShippable"
        [papers]="kanbanSelected.papers"
        [imageEmpty]="kanbanSelected.imageEmpty"
        [messageEmpty]="kanbanSelected.messageEmpty"
        (eventCard)="eventCard(kanbanSelected.signStatus, $event)"
        (eventKanban)="eventKanbanEmitter(kanbanSelected.signStatus, $event)"
        (eventCarregarMaisItens)="carregarMaisPorStatus(kanbanSelected.signStatus)"
      ></app-kanban-documents-field>
    </div>
  </div>
</div>
<app-modal-confirm-descart-paper-no-action></app-modal-confirm-descart-paper-no-action>
